<template>
    <div>
        <!-- 流程步骤条：用 HTML 实现，文字始终清晰（移动端不用缩放图片） -->
        <ul class="stepBar">
            <li v-for="(item, index) in stepList" :key="index" class="stepItem">
                <span class="stepNum">{{ index + 1 }}</span>
                <span class="stepText">{{ item }}</span>
            </li>
        </ul>

        <el-row class="addBtnRow">
            <el-button type="primary" size="small" @click="add_dialog.show = true">新增改表修复申请</el-button>
        </el-row>

        <el-row class="filterRow">
            <el-select v-model="queryParams.type" placeholder="请选择彩种" size="small">
                <el-option label="双色球" value="00"></el-option>
                <el-option label="大乐透" value="01"></el-option>
                <el-option label="福彩3D" value="02"></el-option>
                <el-option label="排列三" value="03"></el-option>
            </el-select>
            <el-select v-model="queryParams.excleType" placeholder="请选择申请类型" size="small">
                <el-option label="闲置" value="0"></el-option>
                <el-option label="定制" value="1"></el-option>
            </el-select>
            <el-button type="primary" size="small" @click="getList">查询</el-button>
        </el-row>

        <div v-loading="tableLoading">
            <el-empty v-if="tableData.length === 0" description="暂无数据"></el-empty>

            <!-- 移动端：表格横向可滑动，避免列被压扁 -->
            <div class="tableScroll" v-else>
            <el-table :data="tableData">
                <el-table-column label="彩种">
                    <template slot-scope="scope">
                        {{getMapping(scope.row.type,'lotteryType')}}
                    </template>
                </el-table-column>
                <el-table-column label="闲置/定制">
                    <template slot-scope="scope">
                        {{getMapping(scope.row.excleType,'excleType')}}
                    </template>
                </el-table-column>
                <el-table-column label="文件名">
                    <template slot-scope="scope">
                        <div class="fileName" :title="getMapping(scope.row.oldExcel,'fileName')">
                            {{getMapping(scope.row.oldExcel,'fileName')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="议价">
                    <template slot-scope="scope">
                        {{scope.row.suggestsPrice}}
                    </template>
                </el-table-column>
                <el-table-column label="打款">
                    <template slot-scope="scope">
                        {{scope.row.price}}
                    </template>
                </el-table-column>
                <el-table-column label="修改文件">
                    <template slot-scope="scope">
                        <div @click="downFile(scope.row)" class="downFile">
                            {{getMapping(scope.row.newExcel,'fileName')}}
                        </div>
                    </template>
                </el-table-column>
				<el-table-column label="时间">
                    <template slot-scope="scope">
						{{ convertToYearMonthDayHourMinuteSecond(scope.row.createTime) }}
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.node == 2" v-loading="scope.row.payBtnLoading" class="payBtns">

                            <el-button type="text" class="payBtn wx" @click="makeAPayment('wxpay', scope.row)">微信打款</el-button>
                            <el-button type="text" class="payBtn ali" @click="makeAPayment('alipay',scope.row)">支付宝打款</el-button>
                            <el-button type="text" class="payBtn bal" @click="makeAPayment('balancepay',scope.row)">余额打款</el-button>

                        </div>
                        <el-button v-else type="text" @click="editItem(scope.row)">{{getMapping(scope.row.node,'step')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            </div>

            <div class="pagin">
                <el-pagination background layout="prev, pager, next" :page-size="queryParams.pageSize" :total="queryParams.total" :current-page.sync="queryParams.pageNum" @current-change="getList">
                </el-pagination>
            </div>

        </div>

        <el-dialog title="添加" :visible.sync="add_dialog.show" :close-on-click-modal="false">
            <el-form class="dlgForm">
                <h3>一,申请</h3>
                <el-form-item label="申请彩种">
                    <el-select v-model="form.type" placeholder="请选择彩种">
                        <el-option v-for="(item, index) in lotteryArr" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="申请类型">
                    <el-select v-model="form.excleType" placeholder="闲置/定制">
                        <el-option v-for="(item, index) in excleTypeArr" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <h3>二,上传该彩种excel表以及修改或者修复需求说明(附在excel里说明)</h3>
                <p v-if="form.oldExcel" class="curFile">当前文件：{{getMapping(form.oldExcel,'fileName')}} <span class="delFile" @click="form.oldExcel=''">删除</span> </p>
                <el-form-item v-else label="上传文件">
                    <el-upload class="upload-demo" drag action :auto-upload="false" :limit="1" :on-change="uploadChange" v-loading="uploadLoading">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" size="small" @click="confirmSave" :loading="confirmLoading">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="支付" :visible.sync="showPayCode" :close-on-click-modal="false">
            <div class="payDlg">
                <p>请使用 <b>{{payCodeMessage}}</b> 扫码支付</p>
                <p class="payTip">扫码支付成功后, 若状态未更新, 请刷新下页面</p>
                <div v-if="showPayCode" ref="qrcode" class="qrcode"></div>
            </div>
        </el-dialog>

        <el-dialog title="验收交付" :visible.sync="acceptance.show" :close-on-click-modal="false">
            <el-form class="dlgForm">
                <el-form-item>
                    <el-radio-group v-model="acceptance.radio">
                        <el-radio label="满意"></el-radio>
                        <el-radio label="不满意"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="acceptance.radio === '不满意'">
                    <el-input v-model="acceptance.message" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="funAcceptance">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import { queryUuIdInfo, createOrder } from "@/api/common";
import a from '@/components/a.vue';
export default {
    components: { a },

	computed:{
		convertToYearMonthDayHourMinuteSecond() {
			return function(isoString){
				const date = new Date(isoString); // 将 ISO 8601 格式字符串转换为 Date 对象
				const year = date.getFullYear(); // 获取年份
				const month = String(date.getMonth() + 1).padStart(2, '0'); // 获取月份，加 1 是因为 getMonth() 返回的月份是从 0 开始的，padStart 用于补全两位数字
				const day = String(date.getDate()).padStart(2, '0'); // 获取日期
				const hour = String(date.getHours()).padStart(2, '0'); // 获取小时
				const minute = String(date.getMinutes()).padStart(2, '0'); // 获取分钟
				const second = String(date.getSeconds()).padStart(2, '0'); // 获取秒
	
				return `${year}-${month}-${day} ${hour}:${minute}:${second}`; // 按照年月日时分秒的格式拼接字符串
			}
		}
	},

    data () {
        return {
            // 流程步骤条
            stepList: [
                '定改修表提交',
                '特约行家划价建议',
                '打款',
                '特约技术员工作',
                '验收交付',
                '交易完成',
            ],
            acceptance: {
                show: false,
                radio: '满意',
                message: '',
				item:{}
            },
            lotteryArr: [
                { value: '00', label: '双色球' },
                { value: '01', label: '大乐透' },
                { value: '02', label: '福彩3D' },
                { value: '03', label: '排列三' },
            ],
            excleTypeArr: [
                { value: '0', label: '闲置' },
                { value: '1', label: '定制' },
            ],
            add_dialog: {
                show: false,
            },

            form: {
                type: '00',
                excleType: '0',
                node: '1',
                oldExcel: '',
            },

            queryParams: {
                type: '00',
                excleType: '0',
                userId: '',

                pageNum: 1,
                pageSize: 10,
                total: 0,
            },

            tableData: [],
            tableLoading: false,

            uploadLoading: false,

            confirmLoading: false,

            showPayCode: false,
            payCodeMessage: '',

            socket: null, // Socket连接对象
            ws: {},

            payItem: {},

        }
    },
    created () {
        this.queryParams.userId = this.vuex_userInfo.userId
    },
    mounted () {
        this.getList()
    },
    methods: {

        downFile (item) {
            let a = document.createElement('a')
            a.href = process.env.VUE_APP_BASE_API + item.newExcel,
                a.download = this.getMapping(item.newExcel, 'fileName')
            a.click()
        },

        funSocket () {
            return new Promise(resolve => {
                let wsUrl = `${process.env.VUE_APP_BASE_WS}/stage-api/pay-websocket/${this.vuex_token}?userId=${this.vuex_userInfo.userId}&businessType=pay`
                this.ws = new WebSocket(wsUrl)
                this.ws.onopen = _ => {
                    console.log("WebSocket is open now.")
                    resolve()
                };

                this.ws.onmessage = event => {
                    console.log("Message from server ", event.data);
                    let { code, msg } = JSON.parse(event.data)
                    if (msg == '支付成功') {
                        this.showPayCode = false
                        this.$alert(msg, '提示', { confirmButtonText: '确定', });

                        // 闲置定制表修改进度修改
                        this.$http.post('/stage-api/technicianIdle/updateTechnicianIdle', {
                            id: this.payItem.params.item_id,
                            suggestsPrice: this.payItem.money,
                            price: this.payItem.money,
                            node: 3,
                            // status
                            // remark
                            // newExcle
                            // acceptance

                        }).then(res => {
                            this.$message.success('成功');
                            this.getList()
                        })


                    }
                }

            })
        },

        // 打款
        makeAPayment (payType, item) {
            item.payBtnLoading = true;

            this.funSocket().then(res => {

                // 查看商品信息
                this.$http.post('/stage-api/technicianIdle/queryTechnicianIdleByRecordId', {
                    id: item.id,
                }).then(res => {
                    let { price, productId, specsId, technicianIdleId } = res.data;

                    let params = {
                        money: price,									//支付金额
                        payType,					 //选择				//支付类型 : wxpay:微信支付;alipay:阿里支付;balancepay:余额支付
                        productId,										//商品id
                        productModel: '1',										//商品模块:商品所属模块;0:预测缩水单商品;1:excel专场商品;2:缩水软件特区商品;3:个人中心充值;4:个人中心提现5:投注站帮扶中心
                        quantity: '1',											//商品数量
                        title: new Date().getTime(),   							//商品标题
                        productSpecsId: specsId,									//商品规格ID
                        productAuthor: item.userId,										//商家ID
                        uuid: new Date().getTime(),
                        params: {
                            item_id: item.id,
                        }
                    }

                    this.payItem = params

                    this.fun_createOrder(params, item)

                })
            })
        },

		// 验收
		funAcceptance(){
			if(this.acceptance.radio == '满意'){ this.acceptance.message = '' }
			let {radio,message,item} = this.acceptance

			let params = {
				price: item.price,
				id: item.id,
				suggestsPrice: item.suggestsPrice,
				node: item.node * 1 + 1,
				acceptance: message ||  radio,
			}
			
			this.$http.post('/stage-api/technicianIdle/updateTechnicianIdle', params).then(res => {
				this.$message.success('成功');
				this.getList()
				this.acceptance.show = false
			})
		},

        editItem (item) {
            console.log('item', JSON.parse(JSON.stringify(item)));
            // 验收
            if (item.node == 4) {

                this.acceptance.show = true
				this.acceptance.item = item

            }
        },

        fun_createOrder (payParams, item) {
			console.log('payParams',payParams);
			console.log('item',JSON.parse(JSON.stringify(item)));
            return new Promise((resolve, reject) => {
                // 创建订单
                createOrder(payParams).then(res => {
                    if (res.code == 200) {

                        if (['wxpay', 'alipay'].includes(payParams.payType)) {
                            this.showPayCode = true;
                            this.payCodeMessage = res.data.payType.displayName;
                            console.log('createOrder res', res);
                            this.$nextTick(() => {
                                new QRCode(this.$refs.qrcode, {
                                    text: res.data.codeUrl,
                                    width: 128 * 2,
                                    height: 128 * 2
                                });
                            });
                        }

                        if (payParams.payType == 'balancepay') {
                            this.$message.success('余额支付成功')

							// 闲置定制表修改进度修改
							this.$http.post('/stage-api/technicianIdle/updateTechnicianIdle', {
								id: this.payItem.params.item_id,
								suggestsPrice: this.payItem.money,
								price: this.payItem.money,
								node: 3,
							}).then(res => {
								this.$message.success('成功');
								this.getList()
							})
                        }
                        resolve()
                    } else {
                        this.$message.error(res.msg)
                    }
                }).finally(_ => {
                    item.payBtnLoading = false
                })
            })
        },


        getMapping (value, type) {
            if (value) {
                if (type === 'lotteryType') {
                    return value === '00' ? '双色球' : value === '01' ? '大乐透' : value === '02' ? '福彩3D' : value === '03' ? '排列三' : ''
                }
                if (type === 'excleType') {
                    return value === '0' ? '闲置' : value === '1' ? '定制' : ''
                }
                if (type === 'step') {
                    return value === '1' ? '等待后台修表人员处理' : value === '2' ? '打款' : value === '3' ? '特约技术工作中' : value === '4' ? '验收交付' : value === '5' ? '交易完成' : ''
                }
                if (type === 'fileName') {
                    let findUrlIndex = value.lastIndexOf('/');
                    return value ? value.substr(findUrlIndex + 1) : ''
                }
            }
        },
        getList () {
            this.tableLoading = true
            this.tableData = []

            let params = this.$utils.getParamByJson(this.queryParams);
            this.$http.get('/stage-api/technicianIdle/list?' + params).then(res => {
                console.log('getList', JSON.parse(JSON.stringify(res)))
                this.tableLoading = false
                res.rows.forEach(item => item.payBtnLoading = false)
                this.tableData = res.rows
                this.queryParams.total = res.total
            }).catch(err => {
                this.tableLoading = false
            })
        },
        async uploadChange (file,) {
            try {
                this.uploadLoading = true
                let params = this.$utils.getParamByJson({ bizId: await queryUuIdInfo(), fileType: "excel_release_txt", number: 1, })
                this.$utils.upLoadFile('?' + params, { file: file.raw }).then((res) => {
                    this.form.oldExcel = res.data.urls
                    this.uploadLoading = false
                });
            } catch (err) {
                console.log('err', err);
                this.uploadLoading = false
            }
        },
        confirmSave () {
            if (this.form.oldExcel == '') {
                return this.$message.error('请上传文件')
            }
            this.confirmLoading = true
            this.$http.post('/stage-api/technicianIdle/repplyTechnicianIdle', this.form).then(res => {
                this.$message.success('保存成功')
                this.add_dialog.show = false
                this.getList()
                this.resetForm()
            })
                .finally(fin => {
                    this.confirmLoading = false
                })

        },

        resetForm () {
            this.form = {
                type: '00',
                excleType: '0',
                node: '1',
                oldExcel: '',
            }
        }
    }
}
</script>

<style lang="scss" scoped>
/* ===== 流程步骤条 ===== */
.stepBar {
    display: flex;
    align-items: flex-start;
    list-style: none;
    margin: 0 0 20px;
    padding: 0;
    width: 100%;
}

.stepItem {
    flex: 1 1 0;
    min-width: 0;
    position: relative;
    text-align: center;
    padding: 0 4px;

    /* 步骤之间的连线 */
    &::before {
        content: '';
        position: absolute;
        top: 11px;
        left: -50%;
        width: 100%;
        height: 2px;
        background-color: #f0a020;
        z-index: 0;
    }

    &:first-child::before {
        display: none;
    }
}

/* 序号方框 */
.stepNum {
    position: relative;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border: 1px solid #2899df;
    border-radius: 3px;
    background-color: #ffffff;
    color: #2899df;
    font-size: 13px;
    font-weight: 600;
}

/* 步骤文字 */
.stepText {
    display: block;
    margin-top: 6px;
    font-size: 13px;
    line-height: 1.5;
    color: #333333;
    word-break: break-word;
}

.pagin {
    width: fit-content;
    margin: 20px auto;
}
.fileName {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
}

/* 顶部操作按钮行 */
.addBtnRow {
    margin-bottom: 4px;
}

/* 筛选行：两个下拉 + 查询按钮 */
.filterRow {
    margin: 20px 0;

    .el-select {
        margin-right: 10px;
    }

    .el-button {
        margin-left: 10px;
    }
}

/* 表格横向滚动容器 */
.tableScroll {
    width: 100%;
}

/* 打款按钮：竖排三行 */
.payBtns {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.8;
}

.payBtn {
    padding: 0 !important;

    &.wx {
        color: #e64a4a;
    }

    &.ali {
        color: #333333;
    }

    &.bal {
        color: #2899df;
    }
}

/* 修改文件链接 */
.downFile {
    color: #2899df;
    cursor: pointer;
}

/* 弹窗表单 */
.dlgForm {
    h3 {
        font-size: 15px;
        margin: 0 0 12px;
    }
}

.curFile {
    margin: 0 0 10px;
    line-height: 1.6;
    word-break: break-all;
}

.delFile {
    color: #e64a4a;
    cursor: pointer;
}

/* 支付弹窗 */
.payDlg {
    text-align: center;

    p {
        margin: 6px 0;
        line-height: 1.6;
    }
}

.payTip {
    color: #e64a4a;
    font-size: 13px;
}

.qrcode {
    margin: 12px auto 0;
    width: fit-content;
}

/* ===== 移动端适配（屏幕小于 1200px 即生效） ===== */
@media (max-width: 1200px) {
    /* 流程步骤条：改为两列网格，文字完整可读，不再靠缩放图片 */
    .stepBar {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px 8px;
        margin-bottom: 14px;
    }

    .stepItem {
        padding: 0;

        /* 网格布局下不需要连线 */
        &::before {
            display: none;
        }
    }

    .stepNum {
        width: 22px;
        height: 22px;
        font-size: 12px;
    }

    .stepText {
        margin-top: 4px;
        font-size: 13px;
    }

    /* 顶部按钮行 */
    .addBtnRow {
        margin-bottom: 10px;

        .el-button {
            width: 100%;
            font-size: 15px;
            padding: 10px 0;
        }
    }

    /* 筛选行：下拉与按钮各占一行，铺满宽度 */
    .filterRow {
        margin: 12px 0;

        .el-select {
            display: block;
            width: 100%;
            margin-right: 0;
            margin-bottom: 10px;

            .el-input__inner {
                font-size: 15px;
            }
        }

        .el-button {
            width: 100%;
            margin-left: 0;
            font-size: 15px;
            padding: 10px 0;
        }
    }

    /* 表格：横向可滑动，列宽保持不被压扁 */
    .tableScroll {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;

        ::v-deep .el-table {
            min-width: 760px;
        }

        ::v-deep .el-table th,
        ::v-deep .el-table td {
            padding: 8px 0;
            font-size: 13px;
        }
    }

    /* 打款按钮：改为横向并排，避免竖排占高 */
    .payBtns {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 2px 10px;
    }

    /* 分页：居中并允许滚动 */
    .pagin {
        width: 100%;
        margin: 16px 0;
        text-align: center;
        overflow-x: auto;

        ::v-deep .el-pagination {
            padding: 0;
            text-align: center;
            white-space: nowrap;
        }

        ::v-deep .el-pager li,
        ::v-deep .btn-prev,
        ::v-deep .btn-next {
            min-width: 30px;
            margin: 0 2px;
        }
    }

    /* 弹窗表单：label 与控件竖排，控件铺满 */
    .dlgForm {
        ::v-deep .el-form-item {
            display: block;
        }

        ::v-deep .el-form-item__label {
            float: none;
            display: block;
            width: auto !important;
            text-align: left;
            line-height: 1.6;
            padding-bottom: 4px;
            color: #666666;
        }

        ::v-deep .el-form-item__content {
            margin-left: 0 !important;
        }

        ::v-deep .el-select,
        ::v-deep .el-input {
            width: 100%;
        }

        h3 {
            font-size: 14px;
            line-height: 1.7;
        }
    }

    /* 支付弹窗：二维码缩小，避免超出屏幕 */
    .payDlg {
        font-size: 14px;
    }
}
</style>